/**
 * The in-app volume: a 0–100 slider position, mapped to the master gain the synth plays
 * through. Phones offer one system volume for every app at once, so when the fretboard plays
 * alongside a backing track (iReal Pro, YouTube, Spotify) this is the only way to balance the
 * two — hence a top end well above the level the app used to be fixed at.
 */
export const MAX_VOLUME = 100;

/** The slider position that reproduces the app's original fixed loudness (unity gain). */
export const DEFAULT_VOLUME = 40;

export const isVolume = (value: unknown): value is number =>
  Number.isInteger(value) && (value as number) >= 0 && (value as number) <= MAX_VOLUME;

/** Linear in amplitude, like a mixer fader: unity at the default, 2.5× at the top. */
export function gainForVolume(volume: number): number {
  return volume / DEFAULT_VOLUME;
}
